<template>
  <div class="c-monitor">
    <!-- filter -->
    <detail-filter :accountData="accountData" :operator-data="operatorData" @on-change="filterData" />
    <!-- table -->
    <div class="c-table-list">
      <detail-table :loading="loading" :data="tableList" :columns="tableCol" @on-retry="retryDetail" />
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page"
        slot="pagination"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/personalcontrol_detail_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, deepCopy } from '@/common/js/utils'
import { consumeManageDetailQuery, consumeManageRetry } from '@/api/manage.model'
import DetailFilter from './components/detail-filter'
import DetailTable from './components/detail-table'
import { adAccount, getSysMember } from '@/api/common.model'
export default {
  name: 'personalcontroldetail',
  mixins: [mixin],
  components: { DetailFilter, DetailTable },
  data() {
    return {
      ruleId: this.$route.query.ruleId,
      accountData: [],
      operatorData: []
    }
  },
  methods: {
    getData(filter) {
      let params = {
        ruleId: this.ruleId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      consumeManageDetailQuery(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    retryDetail(params) {
      const { id } = params
      this.loading = true
      consumeManageRetry({ detailId: id })
        .then((data) => {
          this.loading = false
          if (data) this.getData()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    preloadData() {
      Promise.all([adAccount({ authFlag: 1 }), getSysMember()]).then((data) => {
        const [accountData, operatorData] = data
        if (isArray(accountData)) this.accountData = deepCopy(accountData)
        if (isArray(operatorData)) this.operatorData = deepCopy(operatorData)
      })
    },
    setLocalPage(size) {
      setLocal('PERSONALCONTRL_DETAIL_PAGESIZE', size)
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('PERSONALCONTRL_DETAIL_PAGESIZE')) || 20
    this.tableCol = columns
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-monitor {
  height: 100%;
}

.c-table-list {
  height: calc(100% - 32px);
  margin-top: 8px;
}

.c-table-page {
  text-align: right;
}
</style>
